import { getApiKey } from "../../../utils/apiKey";
import React from "react";
import { apiCall_domainV2 } from "../../api";
import Spinner from "../../Spinner/Spinner";
import axios from "axios";
import Header from "../../header";
import Gift from "./Gift";
class Bazarche extends React.Component {
  state = {
    data: null,
    loading: true,
  };
  // api gets
  componentWillMount() {
    const headers = {
      Authorization: getApiKey(),
      "content-type": "application/json",
    };
    axios
      .get(`${apiCall_domainV2}/customer/market/gifts`, {
        headers,
      })
      .then((res) => {
        this.setState({ loading: false, data: res.data });
      })
      .catch();
  }

  render() {
    return (
      <div className="bazarchePageContainer">
        {this.state.loading ? (
          <Spinner />
        ) : (
          <>
            <Header showSearchBar={true} title={"بازارچه"} />

            {this.state.data.gifts.length ? (
              <div className="bazarcheItems">
                {this.state.data.gifts.map((gift) => (
                  <Gift data={gift} />
                ))}
              </div>
            ) : (
              <div className="emptyText">
                <span className="danger">هیج کد تخفیف وجود ندارد</span>
              </div>
            )}
          </>
        )}
      </div>
    );
  }
}
export default Bazarche;
